import styled from 'styled-components';
import { PrimaryButtonDarkTheme, SecondaryButton } from '../elements';
import AlertIcon from '../icons/alert.svg?react';

const Error = () => {
  const handleRefresh = () => {
    window.history.back();
  };

  const handleContactSupport = () => {
    window.open('https://coterieinsurance.com/support/', '_blank');
  };

  return (
    <ErrorContainer>
      <WarningIcon />
      <ErrorHeader>Oh no, something went wrong!</ErrorHeader>
      <ErrorText>We encountered an unexpected error while loading this page. Please refresh and try again.</ErrorText>
      <ErrorText>If the problem persists, please contact us or chat with our Support Team.</ErrorText>
      <ButtonContainer>
        <RefreshButton onClick={handleRefresh}>Refresh Page</RefreshButton>
        <ContactSupportButton onClick={handleContactSupport}>Contact Support</ContactSupportButton>
      </ButtonContainer>
    </ErrorContainer>
  );
};

export default Error;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  width: auto;
`;

const WarningIcon = styled(AlertIcon)`
  margin-top: 100px;
  @media (max-width: 767px) {
    margin-top: 0px;
  }
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
  g {
    fill: ${(props) => props.theme.pageComponents.errorModal.textColor};
  }
`;
const ErrorHeader = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-family: ${({ theme }) => theme.font.typeface.primary};
  color: ${(props) => props.theme.colors.tertiary.zero};
`;

const ErrorText = styled.p`
  font-size: 18px;
  color: ${(props) => props.theme.colors.neutral.dark};
  line-height: 1.6;
  font-family: ${({ theme }) => theme.font.typeface.secondary};
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2.5rem;
`;
const RefreshButton = styled(PrimaryButtonDarkTheme)`
  margin: 0;
`;

const ContactSupportButton = styled(SecondaryButton)`
  margin: 0;
`;
